import { useTranslation } from "react-i18next";
import { mainURL } from "../utils/common";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { RenderNavItem } from "../components/RenderNavItem";
import { RecruitmentResultTrainingLeftMenuList } from "../utils/constants";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";

const KMC_Recruitments = () => {
  const { t } = useTranslation();

  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="img" />
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  ">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {RecruitmentResultTrainingLeftMenuList.map(
                      (item, index) => (
                        <RenderNavItem
                          key={item.id || index}
                          item={item}
                          index={index}
                          t={t}
                        />
                      )
                    )}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2 bas">
                    <h3 className="fontSizeClass"> {t("Recruitments")} </h3>
                  </div>
                  <div className="mayor-table health-dept-table m-ta-2">
                    <table className="table table-bordered officials">
                      <tbody>
                        <tr bgcolor="#302ba0" tabIndex={0} align="center" valign="middle">
                          <td width="90%" className="text-white tble-brder-left">
                            {t("Description")}
                          </td>
                          <td width="10%" className="text-white">
                            {t("Date")}
                          </td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                          <DownloadFileByFileStoreId fileStoreId="" label="Vacancy Circular for appointment of Sr. Architect in Andaman Public Works Department, A&N Administration on deputation (ISTC) basis for a period of 03 years."  />

                            {/* <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18039426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}> </a> */}
                          </td>
                          <td>07.05.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18039426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}>
                              Engagement of 86 nos. Staff Nurse contractual for
                              Khidderpure U-CHC in the Kolkata City NUHM Society
                              under Health Department of KMC Advt. No.
                              08/Kolkata City NUHM Society/2025 - 26. dated:
                              27.02.2026
                            </a>
                          </td>
                          <td>28.02.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18039526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 13 nos. Laboratory Technicians
                              contractual for its Urban Primary Health Centers
                              in Kolkata City NUHM Society under Health
                              Department of KMC Advt. No. 07/Kolkata City NUHM
                              Society/2025 - 26. dated: 26.02.2026
                            </a>
                          </td>
                          <td>27.02.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18039626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 26 nos. Pharmacist contractual for
                              its Urban Primary Health Centers in Kolkata City
                              NUHM Society under Health Department of KMC Advt.
                              No. 06/Kolkata City NUHM Society/2025 - 26. dated:
                              26.02.2026
                            </a>
                          </td>
                          <td>27.02.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18039726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Cancellation of Advertisement no 05/Kolkata City
                              NUHM Society/2023-24 dated 15.07.2023. for the
                              post of Laboratory Technicians
                            </a>
                          </td>
                          <td>27.02.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18039826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Cancellation of Advertisement no 08/Kolkata City
                              NUHM Society/2023-24 dated 25.11.2023. for the
                              post of Pharmacist
                            </a>
                          </td>
                          <td>27.02.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18039926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 33 nos. Counsellor contractual for
                              Polyclinics under XV Finance Commission under
                              Health Department of KMC Advt. No.
                              H/07/KMC/2025-26. dated: 23.02.2026
                            </a>
                          </td>
                          <td>23.02.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18040026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 30.01.2026, for the post of
                              Medical Officer Specialist (G&O, Medicine,
                              Paediatrics, Ophthalmologist, Cardiology,
                              Radiology, ENT, and Orthopaedics) on contractual
                              basis for UHWC under XV Finance Commission under
                              the Health Department of Kolkata Municipal
                              Corporation. Adv. No . H/06/KMC/2025-26. dated
                              16.01.2026
                            </a>
                          </td>
                          <td>16.01.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18040126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 21.01.2026, 03 no. of Lab
                              Assistant for Central Lab (food) on contractual
                              basis under the Health Department of Kolkata
                              Municipal Corporation against Adv. No .
                              H/05/KMC/2025-26 dated. 06.01.2026.
                            </a>
                          </td>
                          <td>06.01.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18040226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 20.01.2026, for the post of
                              Medical for U-CHC at Khidderpore under Kolkata
                              City NUHM Society. Adv. No . 05/Kolkata City NUHM
                              Society/2025-26. dated 06.01.2026
                            </a>
                          </td>
                          <td>26.01.2026</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18040326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 19.12.2025, 01 no. Senior
                              Entomologist on contractual basis for Vector
                              Control against Adv. No . H/04/KMC/2025-26. dated
                              09.12.2025
                            </a>
                          </td>
                          <td>09.12.2025</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18040426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              The 2nd list of selected candidate's names for the
                              post of Medical Officer on contractual basis under
                              Kolkata City NUHM Society under Health Department
                              of KMC against Adv. No - 01/Kolkata City NUHM
                              Society/2025 - 26. dated 11.09.2025
                            </a>
                          </td>
                          <td>06.12.2025</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18040526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 12.12.2025, for the post of
                              Medical Officer Specialist (G&O), Peadiatric and
                              Anesthetist for U-CHC at Khidderpore under Kolkata
                              City NUHM Society. Adv. No . 04/Kolkata City NUHM
                              Society/2025-26. dated 02.12.2025
                            </a>
                          </td>
                          <td>02.12.2025</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18040626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Cancellation of Advertisement no H/09/KMC/2023-24.
                              dated 09.12.2023. for the post of Assistant
                              Analyst and Lab Assistant.
                            </a>
                          </td>
                          <td>25.11.2025</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18040726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 10.12.2025 And 11.12.2025,
                              04no. of Assistant Analyst And 03 no. of Lab
                              Assistant contractual basis under the Health
                              Department of Kolkata Municipal Corporation
                              against Adv. No . H/03/KMC/2025-26 dated.
                              24.11.2025.
                            </a>
                          </td>
                          <td>24.11.2025</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18040826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 28.11.2025 for the post of
                              Medical Officer on contractual basis for UHWC
                              under XV Finance Commission under the Health
                              Department of Kolkata Municipal Corporation. Adv.
                              No . H/02/KMC/2025-26. dated 19.11.2025
                            </a>
                          </td>
                          <td>19.11.2025</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18040926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 139 nos. Staff Nurse contractual for
                              Urban Primary Health Centers under Kolkata City
                              NUHM Society under Health Department of KMC Advt.
                              No. 03/Kolkata City NUHM Society/2025 - 26. dated
                              17.11.2025
                            </a>
                          </td>
                          <td>17.11.2025</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18041026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 17 nos. Accountant-I vide Advt. No.
                              02/Kolkata City NUHM Society/2025-26 dated
                              18.10.2025
                            </a>
                          </td>
                          <td>18.10.2025</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18041126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Cancellation of Advertisement No. 06/Kolkata City
                              NUHM Society/2023-24 dated 05.08.2023. for the
                              post of Accountant-I
                            </a>
                          </td>
                          <td>17.10.2025</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18041226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of superannuated government employees
                              in various posts at Kolkata Municipal Corporation
                              Sustainability, Hygiene and Resilience Project
                              (KMC-SHARP) on purely contract basis
                            </a>
                          </td>
                          <td>17.10.2025</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18041326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of STS, PMDT HIV Coordinator, LT, TBHV
                              and MO(NTEP) under National Tuberculosis
                              Elimination Programme on contractual basis against
                              Memo. No . KDTCS/Office/198/25. dated 13.10.2025
                            </a>
                          </td>
                          <td>13.10.2025</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18041426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 19.09.2025, 37 nos. Medical
                              Officer on contractual basis for Kolkata City NUHM
                              Society against Adv. No . 01/Kolkata City NUHM
                              Society/2025-26. dated 11.09.2025
                            </a>
                          </td>
                          <td>11.09.2025</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18041526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 1 no. Operator for LCMSMS, 1 no.
                              Operator for GCMSM and 1no. Operator for ICPMS for
                              New Food Laboratory under Health Department of KMC
                              vide Advt. No. H01KMC2025-26. dated 30.08.2025
                            </a>
                          </td>
                          <td>30.08.2025</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18041626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Cancellation of Advertisement for the post of
                              Driver for Modified Food Safety on Wheels
                            </a>
                          </td>
                          <td>03.10.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18041726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Applications are invited from the eligible
                              candidates, superannuated / to be superannuated on
                              or before 31st December, 2024, for engagement to
                              the post of Special Officer (Building) in KMC, to
                              hear and deal with the matter U/S 400, Sub-Sec.(I)
                              and 416 of The KMC Act, 1980
                            </a>
                          </td>
                          <td>24.09.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18041826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Applications are invited from the Superannuated/to
                              be superannuated (by 31.12.2024) Govt. Officers
                              for selection and appointment on re-employment
                              basis to the post of Hearing Officer in KMC.
                            </a>
                          </td>
                          <td>11.09.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18041926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 16.07.2024, 2 nos. Medical
                              officer Specialist for Khidderpore U-CHC under the
                              Kolkata City NUHM Society on contractual basis,
                              Adv. No . 02/Kolkata City NUHM Society/2024 25.
                              dated 10.07.2024
                            </a>
                          </td>
                          <td>10.07.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18042026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 21.06.2024, for the post of
                              Specialist (G&O, Medicine, Paediatrics,
                              Ophthalmologist, Cardiology, ENT, and
                              Orthopaedics) on contractual basis under the
                              Health Department of Kolkata Municipal
                              Corporation. Adv. No . H/01/KMC/202425. dated
                              08.06.2024
                            </a>
                          </td>
                          <td>10.06.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18042126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview held on 14.06.2024, 67 nos.
                              Medical officer (part time) contractual basis
                              under the Kolkata City NUHM Society. Adv. No .
                              01/Kolkata City NUHM Society/2024 25. dated
                              07.03.2024
                            </a>
                          </td>
                          <td>07.06.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18042226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 22.03.2024, for the post of
                              Specialist Medical Officer (G&O) on contractual
                              basis under the Health Department of Kolkata
                              Municipal Corporation. Adv. No . H/010/KMC/202324.
                              dated 14.03.2024
                            </a>
                          </td>
                          <td>15.03.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18042326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 4 nos. Assistant Analyst and 3 nos.
                              Lab Assistant on contractual basis for Central Lab
                              (Food) under the Health Department of Kolkata
                              Municipal Corporation. Adv. No . H/09/KMC/202324.
                              dated 09.12.2023
                            </a>
                          </td>
                          <td>12.02.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18042426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 1no. Nursing in-charge for
                              Khidderpore (U-CHC) under Kolkata City NUHM
                              Society on contractual basis, Adv. No . 14/Kolkata
                              City NUHM Society/2023 24. dated 24.11.2023
                            </a>
                          </td>
                          <td>12.02.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18042526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 1no. Medical officer in-charge for
                              Khidderpore (U-CHC) under Kolkata City NUHM
                              Society on contractual basis, Adv. No . 13/Kolkata
                              City NUHM Society/2023 24. dated 24.11.2023
                            </a>
                          </td>
                          <td>12.02.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18042626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 27.02.2024, for the post of
                              Specialist ( Medicine and Pathologist) for U-CHC
                              Khidderpore under Kolkata City NUHM Society. Adv.
                              No . 09/Kolkata City NUHM Society/202324. dated
                              07.12.2023
                            </a>
                          </td>
                          <td>12.02.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18042726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 23.02.2024, for the post of
                              Specialist (Medicine, Ophthalmologist, Cardiology,
                              ENT, Endocrinology and Orthopaedics) on
                              contractual basis under XV FC under the Health
                              Department of Kolkata Municipal Corporation. Adv.
                              No . H/08/KMC/202324. dated 10.01.2024
                            </a>
                          </td>
                          <td>12.02.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18042826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview held on 20.02.2024, 75nos.
                              Medical officer (part time) contractual basis
                              under the Kolkata City NUHM Society. Adv. No .
                              11/Kolkata City NUHM Society/2023 24. dated
                              27.01.2024
                            </a>
                          </td>
                          <td>12.02.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18042926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 118 nos. Honorary Health Workers
                              (HHW) under Health Department of KMC vide Advt.
                              No. H/07/KMC/2023-24. dated 22.11.2023
                            </a>
                          </td>
                          <td>05.02.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18043026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Notice for cancellation of Advertisement for
                              appointment to the Special Officer(Building)
                            </a>
                          </td>
                          <td>18.01.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18043126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview held on 09.01.2024, 68nos.
                              Medical Officer (part time) contractual basis
                              under the Kolkata City NUHM Society against Adv.
                              No . 10/Kolkata City NUHM Society/2023 24. dated
                              07.12.2023
                            </a>
                          </td>
                          <td>04.01.2024</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18043226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Recruitment Regulations for the posts
                              Sub-Registrar under Health Department, KMC. dated
                              28.12.2023
                            </a>
                          </td>
                          <td>28.12.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18043326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 22.12.2023, for the post of
                              Specialist (G&O, Medicine, Paediatrics,
                              Ophthalmologist, Cardiology, ENT, Endocrinology
                              and Orthopaedics) on contractual basis under XV FC
                              of Kolkata Municipal Corporation. Adv. No .
                              H/06/KMC/202324. dated 07.12.2023
                            </a>
                          </td>
                          <td>16.12.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18043426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 21.12.2023, for the post of
                              Specialist ( Medicine,Pathologist and
                              Paediatrics,) for U-CHC at Khidderpore under
                              Kolkata City NUHM Society. Adv. No . 09/Kolkata
                              City NUHM Society/202324. dated 07.12.2023
                            </a>
                          </td>
                          <td>16.12.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18043526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 19 nos. Pharmacist (contractual) for
                              Urban Primary Health Centers under Kolkata City
                              NUHM Society. Advt. No. 08/Kolkata City NUHM
                              Society/2023 24, dated: 25.11.2023
                            </a>
                          </td>
                          <td>08.12.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18043626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 07 nos. Staff Nurse for Polyclinic
                              on contractual basis under XV Finance Commission.
                              Advt. No. H/05/KMC/2023-24. dated 13.10.2023
                            </a>
                          </td>
                          <td>08.12.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18043726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 29 nos. Staff Nurse for UHWC on
                              contractual basis under XV Finance Commission.
                              Advt. No. H/04/KMC/2023-24. dated 13.10.2023
                            </a>
                          </td>
                          <td>08.12.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18043826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 22.11.2023, 24nos. Medical
                              officer (part time) on contractual basis under the
                              Kolkata City NUHM Society , Adv. No . 08/Kolkata
                              City NUHM Society/2023 24. dated 07.10.2023
                            </a>
                          </td>
                          <td>06.11.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18043926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview held on 22.09.2023, 29nos. of
                              Medical officer (part time) contractual basis
                              under the Kolkata City NUHM Society, Adv. No .
                              07/Kolkata City NUHM Society/2023 24. dated
                              21.08.2023
                            </a>
                          </td>
                          <td>12.09.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18044026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 29.08.2023 26nos. of Medical
                              Officer on contractual basis for Urban Health &
                              Wellness Centre under the Health Department of
                              Kolkata Municipal Corporation Advertisement No .
                              H/03/KMC/2023-24 dated. 07.08.2023
                            </a>
                          </td>
                          <td>18.08.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18044126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 17nos. of Accountant-I under Kolkata
                              City NUHM Society on contractual basis.
                              Advertisement no 06/Kolkata City NUHM Society/2023
                              24 dated: 05.08.2023
                            </a>
                          </td>
                          <td>16.08.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18044226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Contractual Appointment
                            </a>
                          </td>
                          <td>04.08.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18044326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 19.08.2023, for the post of
                              Specialist (G&O, Medicine, Paediatrics,
                              Ophthalmologist, Cardiology, ENT, Endocrinology
                              and Orthopaedics) on contractual basis under the
                              Health Department of Kolkata Municipal Corporation
                              against Adv. No . H/02/KMC/202324. dated
                              15.07.2023
                            </a>
                          </td>
                          <td>01.08.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18044426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 8 nos. Laboratory Technicians on
                              contractual basis under the Kolkata City NUHM
                              Society against Adv. No . 05/Kolkata City NUHM
                              Society/202324. dated 15.07.2023
                            </a>
                          </td>
                          <td>24.07.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18044526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 04.08.2023, 59nos. Medical
                              officer (part time) contractual basis under the
                              Kolkata City NUHM Society against Adv. No .
                              04/Kolkata City NUHM Society/2023 24. dated
                              15.07.2023
                            </a>
                          </td>
                          <td>19.07.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18044626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 06.07.2023, 04 nos. Medical
                              Officer on contractual basis for Kidderpore U-CHC
                              under Kolkata City NUHM Society against Adv. No .
                              03/Kolkata City NUHM Society/202324. dated
                              19.06.2023
                            </a>
                          </td>
                          <td>28.06.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18044726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 12.06.2023, 05 nos.
                              Specialist (Surgeon, Orthopedics, Medicine and
                              Anesthetist) on contractual basis for Kidderpore
                              U-CHC under Kolkata City NUHM Society against Adv.
                              No . 02/Kolkata City NUHM Society/202324. dated
                              06.06.2023
                            </a>
                          </td>
                          <td>07.06.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18044826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 12.06.2023, 90 nos.
                              Specialist (G&O, Medicine, Paediatrics,
                              Ophthalmologist, Cardiology, ENT, Endocrinology
                              and Orthopendics) on contractual basis under the
                              Health Department of Kolkata Municipal Corporation
                              against Adv. No . H/01/KMC/202324. dated
                              31.05.2023
                            </a>
                          </td>
                          <td>06.06.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18044926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of STS, STLS, LT, TBHV and MO(NTEP)
                              under National Tuberculosis Elimination Programme
                              on contractual basis against Adv. No .
                              KDTCS/Office/37/23. dated 03.06.2023
                            </a>
                          </td>
                          <td>05.06.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18045026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Corrigendum to Advertisement No. 01/Kolkata City
                              NUHM Society/2023-24. Dated 12.04.2023
                            </a>
                          </td>
                          <td>15.05.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18045126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 22.05.2023, 89nos. Medical
                              officer (part time) contractual basis under the
                              Kolkata City NUHM Society against Adv. No .
                              01/Kolkata City NUHM Society/2023 24. Dated
                              12.04.2023
                            </a>
                          </td>
                          <td>11.05.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18045226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 30nos. of Community Health Assistant
                              (Urban) contractual basis under XV Finance
                              Commission. Advt. No. H/07/KMC/2022-23. Dated
                              20.10.2022
                            </a>
                          </td>
                          <td>27.03.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18045326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 17nos.Staff Nurse for Polyclinic on
                              contractual basis under XV Finance Commission.
                              Advt. No. H/06/KMC/2022-23. Dated 20.10.2022
                            </a>
                          </td>
                          <td>24.03.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18045426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Corrigendum to Advertisement No. H/04/KMC/2022-23.
                              dated 23.02.2023.
                            </a>
                          </td>
                          <td>13.03.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18045526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 20.03.2023 & 21.03.2023,
                              01no. of Analyst & 01 no. of Driver contractual
                              basis under the Health Department of Kolkata
                              Municipal Corporation against Adv. No .
                              H/04/KMC/2022-23 dated. 23.02.2023.
                            </a>
                          </td>
                          <td>09.03.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18045626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 30 nos.Staff Nurse on contractual
                              basis under XV Finance Commission.Advt. No.
                              H/05/KMC/2022-23. Dated 20.10.2022
                            </a>
                          </td>
                          <td>28.02.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18045726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 17nos.Counsellor (contractual) basis
                              under the Health Department of Kolkata Municipal
                              Corporation against Adv. No . H/03/KMC/2022-23
                              dated. 20.10.2022
                            </a>
                          </td>
                          <td>08.02.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18045826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 15.02.2023, 29nos. Medical
                              officer contractual basis under the Kolkata City
                              NUHM Society against Adv. No . 13/Kolkata City
                              NUHM Society/2022 23. dated 28.01.2023
                            </a>
                          </td>
                          <td>03.02.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18045926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 01 no.(only one)
                            </a>
                          </td>
                          <td>21.01.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18046026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 01.02.2023, 55nos. Medical
                              Officer (part time) contractual basis under the
                              Kolkata City NUHM Society against Adv. No .
                              06/Kolkata City NUHM Society/2022 23.
                            </a>
                          </td>
                          <td>19.01.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18046126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Applications are invited from the eligible
                              candidates,superannuated/to be superannuated on or
                              before 31.01.2023, for selection and appointment
                              on re- employment basis to the post of Special
                              Officer (Building) in KMC,to hear and deal with
                              the matter U/S 400, SUB-SEC (I) AND 416 of the KMC
                              ACT,1980
                            </a>
                          </td>
                          <td>17.01.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18046226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 01(only one) no. of Ophthalmic
                              Assistant for Khidderpore U-CHC under Kolkata City
                              NUHM Society on contractual basis. Advt. No.
                              11/Kolkata City NUHM Society/2022 23 Dated:
                              12.11.20222
                            </a>
                          </td>
                          <td>16.01.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18046326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 05 nos.of Staff Nurse for
                              Khidderpore U-CHC under Kolkata City NUHM Society
                              on contractual basis. Advt. No. 10/Kolkata City
                              NUHM Society/2022 23 Dated: 12.11.2022
                            </a>
                          </td>
                          <td>16.01.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18046426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 01 (only one) no. of Pharmacist for
                              Khidderpore U-CHC under Kolkata City NUHM Society
                              on contractual basis. Advt. No. 09/Kolkata City
                              NUHM Society/2022 23 Dated: 12.11.2022
                            </a>
                          </td>
                          <td>16.01.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18046526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 02 nos. of Laboratory Technicians
                              for Khidderpore U-CHC under Kolkata City NUHM
                              Society on contractual basis. Advt. No. 08/Kolkata
                              City
                            </a>
                          </td>
                          <td>16.01.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18046626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ADDENDUM of Notice dated 22.09.2022.
                            </a>
                          </td>
                          <td>05.01.2023</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18046726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 16.12.2022, 68 nos.
                            </a>
                          </td>
                          <td>07.12.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18046826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 14.12.2022, 30 nos.Medical
                              Officer contractual basis under the Kolkata
                              Municipal Corporation(Health Department) against
                              Adv. No . H/01/KMC/202223. dated 20.10.2022.
                            </a>
                          </td>
                          <td>05.12.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18046926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Corrigendum to Advertisement No. 07/Kolkata City
                              NUHM
                            </a>
                          </td>
                          <td>30.11.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18047026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 06.12.2022, 5 nos. Specialist
                              Medical officer & 2 nos. Medical officer
                              contractual basis under the Kolkata City NUHM
                              Society against Adv. No . 07/Kolkata City NUHM
                              Society/2022 23. dated 12.11.2022
                            </a>
                          </td>
                          <td>23.11.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18047126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Applications are invited for contractual
                              engagement of different posts under Air Quality
                              Monitoring Cell, Kolkata Municippal Corporation
                            </a>
                          </td>
                          <td>22.09.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18047226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 23.09.2022,
                            </a>
                          </td>
                          <td>14.09.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18047326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 186 nos. Staff Nurse contractual for
                              its Urban Primary Health Centers in Kolkata City
                              NUHM Society areas against Advt. No. 04/Kolkata
                              City NUHM Society/2022 23.dated: 06.09.2022
                            </a>
                          </td>
                          <td>14.09.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18047426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Application are invited from the eligible women
                              candidates for the post of Honorary Health Worker
                              (HHW) Memo No. H/L/153/2022-23.dated 25.08.2022
                            </a>
                          </td>
                          <td>25.08.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18047526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 285 nos.of Community Health
                              Assistant (Urban) contractual for its Urban
                              Primary Health Centers in Kolkata City NUHM
                              Society areas against
                            </a>
                          </td>
                          <td>01.08.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18047626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              List of Eligible Candidates for Written
                              Examination for Selection of 32 nos of Community
                              Organizers on contractual basis under DAY-NULM in
                              the KMC
                            </a>
                          </td>
                          <td>14.06.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18047726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 12.05.2022, 27nos. Medical
                              officer & 71 nos.Medical officer (part time)
                              contractual basis under the Kolkata City NUHM
                              Society against Adv. No . 02/Kolkata City NUHM
                              Society/2022 23. Dated 30.04.2022
                            </a>
                          </td>
                          <td>30.04.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18047826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 18 nos. Pharmacist for its urban
                              primary health centers in Kolkata City NUHM
                              Society areas on contractual basis. Adv. No .
                              01/Kolkata City NUHM Society/2022 23. Dt.
                              05.04.2022
                            </a>
                          </td>
                          <td>06.04.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18047926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 10.03.2021, 22 nos. Medical
                              officer
                            </a>
                          </td>
                          <td>04.03.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18048026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 2 Software Support Personnel(SSP) on
                              contract basis for e-Office in KMC.
                            </a>
                          </td>
                          <td>24.01.2022</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18048126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 14 nos.of Laboratory Technicians
                              (contractual) for its Urban Primary Health Centers
                              in Kolkata City NUHM Society areas against Advt.
                              No. 09/Kolkata City NUHM Society/2021 22.
                            </a>
                          </td>
                          <td>24.11.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18048226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 29.11.2021, 14 nos. Medical
                              officer & 46 nos. Medical officer (part time)
                              contractual basis under the Kolkata City NUHM
                              Society against Adv. No . 07/Kolkata City NUHM
                              Society/2021 22.
                            </a>
                          </td>
                          <td>20.11.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18048326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 01 Accounts Assistant (contractual)
                              under Kolkata City NUHM Society against Adv. No .
                              08/Kolkata City NUHM Society/2021 22.
                            </a>
                          </td>
                          <td>18.11.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18048426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Notice and application form for the post of
                              District Co-ordinator( IT) & District
                              Co-ordinator(Hospital) on contractual basis for
                              one year.
                            </a>
                          </td>
                          <td>08.11.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18048526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Recruitment Examination, 2021 for the post of
                              Medical Officer (General) under kolkata municipal
                              corporation.
                            </a>
                          </td>
                          <td>22.09.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18048626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 10.09.2021, 18 nos. Medical
                              officer & 55 nos. Medical officer (part time)
                              contractual basis under the Kolkata City NUHM
                              Society against Adv. No . 06/Kolkata City NUHM
                              Society/2021 22.
                            </a>
                          </td>
                          <td>03.09.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18048726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Notice and Application Form for the post of
                              Community Organiser.
                            </a>
                          </td>
                          <td>02.08.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18048826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 20nos. Pharmacist for its urban
                              primary health centers in Kolkata City NUHM
                              Society areas on contractual basis against Advt.
                              No . 03/Kolkata City NUHM Society/2021 22. Dated:
                              06.05.2021.
                            </a>
                          </td>
                          <td>26.07.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18048926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Recruitment for different posts of National
                              Tuberculosis Dated: 06.05.2021.
                            </a>
                          </td>
                          <td>15.07.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18049026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 06.07.2021, 27 nos. Medical
                              officer & 64 nos. Medical officer (part time)
                              contractual basis under the Kolkata City NUHM
                              Society against Adv. No . 05/Kolkata City NUHM
                              Society/2021 22.
                            </a>
                          </td>
                          <td>24.06.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18049126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 30.06.2021, 06 nos.
                            </a>
                          </td>
                          <td>24.06.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18049226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 205 nos Staff Nurse for its urban
                              primary health centers in Kolkata City NUHM
                              Society areas on contractual basis, against Adv.
                              No . 02/Kolkata City NUHM Society/2021 22.
                            </a>
                          </td>
                          <td>08.05.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18049326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 24.05.2021, 71 nos Medical
                              officer (part time) contractual basis under the
                              Kolkata City NUHM Society against Adv. No .
                              04/Kolkata City NUHM Society/2021 22
                            </a>
                          </td>
                          <td>06.05.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18049426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 17.05.2021, 50 nos Medical
                              officer contractual basis under the Kolkata City
                              NUHM Society against Adv. No . 01/Kolkata City
                              NUHM Society/2021 22.
                            </a>
                          </td>
                          <td>06.05.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18049526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Corrigendum to Advertisement no 07/Kolkata City
                              NUHM Society/ 2020-2021
                            </a>
                          </td>
                          <td>03.02.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18049626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 08.02.2021, 46 nos Medical
                              officer (full time) contractual basis under the
                              Kolkata City NUHM Society against Adv. No .
                              07/Kolkata City NUHM Society/2020 21
                            </a>
                          </td>
                          <td>01.02.2021</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18049726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 11.11.2020, 40 nos Medical
                              officer (full time) & 61 nos Medical officer (part
                              time) contractual basis under the Kolkata City
                              NUHM Society against Adv. No . 06/Kolkata City
                              NUHM Society/2020 21
                            </a>
                          </td>
                          <td>05.11.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18049826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Applications are invited through e-mail id:
                              kmc_personnel@kmcgov.in from the Superannuated/to
                              be superannuated Govt. Officers equivalent to the
                              rank of Dy. Secretary & above of the Govt. of West
                              Bengal,for Preparation of Panel regarding
                              engagement of Inquiry Officers on contractual
                              basis, from the said Panel.
                            </a>
                          </td>
                          <td>17.10.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18049926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 09.10.2020,43 nos Medical
                              officer (full time) &
                            </a>
                          </td>
                          <td>01.10.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18050026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 10.09.2020,
                            </a>
                          </td>
                          <td>03.09.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18050126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 26 nos Laboratory Technicians
                            </a>
                          </td>
                          <td>07.08.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18050226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 14.08.2020, 42 nos Medical
                              officer (full time) & 48 nos Medical officer (part
                              time) contractual basis under the Kolkata City
                              NUHM Society against Adv. No . 02/Kolkata City
                              NUHM Society/2020 21
                            </a>
                          </td>
                          <td>04.08.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18050326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              walk-in interview on 17.06.2020, 23 nos Medical
                              Officer full time & 19 nos Medical Office Part
                              time contractual basis under the Kolkata City NUHM
                              Society against Adv. No 01/ Kolkata City NUHM
                              Society/ 2020-21.
                            </a>
                          </td>
                          <td>05.06.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18050426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 16.03.2020, 140 nos Staff
                              NUHM
                            </a>
                          </td>
                          <td>04.03.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18050526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 07.03.2020, 24nos Medical
                              officer (full time)
                            </a>
                          </td>
                          <td>28.02.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18050626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview on 10.02.2020, 25nos Medical
                              officer (full time) & 17nos Medical officer (part
                              time) contractual basis under
                            </a>
                          </td>
                          <td>01.02.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18050726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Contractual Engagement of Two Senior Software
                              Developers.
                            </a>
                          </td>
                          <td>21.01.2020</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18050826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF 28 MEDICAL OFFICER FULL
                              TIME(CONTRACTUAL) RESERVED CAREGORY AND 25 MEDICAL
                              OFFICER PART TIME (CONTRACTUAL) FOR ITS URBAN
                              PRIMARY HELATH CENTRES IN KOLKATA CITY NUHM
                              SOCIETY AREAS ON CONTRATUAL BASIS THROUGH WALK IN
                              INTERVIEW, AGAINST ADV. NO. 03 KOLKATA CITY NUHM
                              SOCIETY /2019-20 AND ADVERTISEMENT NO 03 KOLKATA
                              CITY NUHM SOCIETY /2019-20.
                            </a>
                          </td>
                          <td>01.08.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18050926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Date and Venue of Personality Test for Recruitment
                              of
                            </a>
                          </td>
                          <td>26.07.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18051026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              APPLICATION ARE INVITED FOR ENGAGEMENT OF 45
                              (FORTY FIVE) PHARMACISTS ON CONTRACTUAL BASIS
                              AGAINST ADVERTISEMENT NUMBER 03/KOLKATA CITY NUHM
                              SOCIETY / 2019 - 20.
                            </a>
                          </td>
                          <td>20.07.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18051126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Applicalions are invited from the Officers (State
                              Govt./KMC) Superannuated /to be superannuated
                              on/before 31.08.2019, for selection and
                              appointment on re-appointment basis to the post of
                              Special Officer (Building) in KMC, to deal with
                              matters U/S 400, SUB-SEC.(I) AND 416 Of KMC, ACT
                              1980.
                            </a>
                          </td>
                          <td>12.07.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18051226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF 30 MEDICAL OFFICER FULL
                              TIME(CONTRACTUAL) RESERVED CAREGORY AND 23 MEDICAL
                              OFFICER PART TIME (CONTRACTUAL) FOR ITS URBAN
                              PRIMARY HELATH CENTRES IN KOLKATA CITY NUHM
                              SOCIETY AREAS ON CONTRATUAL BASIS THROUGH WALK IN
                              INTERVIEW, AGAINST ADV. NO. 02 KOLKATA CITY NUHM
                              SOCIETY /2019-20 AND ADVERTISEMENT NO 02 KOLKATA
                              CITY NUHM SOCIETY /2019-20.
                            </a>
                          </td>
                          <td>01.07.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18051326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Corrigendum to Memo No:227/NUHM/KOL/19-20. has
                              been extended up to 4th July 2019.
                            </a>
                          </td>
                          <td>27.06.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18051426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              THE COMPUTER TEST FOR THE POST OF LABORATORY
                              TECHNICIAN UNDER CITY NUHM SOCIETY AS PER
                              ADVERTISEMENT NO.11/KOLAKATA CITY NUHM
                              SOCIETY/2018-19 WILL BE HELD FROM 18.06.2019 TO
                              21.06.2019 AT INSTITUTE OF URBAN MANAGEMNENT
                              (I.U.M), 36C , BALLYGAUNG CIRCULAR ROAD, KOLKATA
                              -700019 AS PER ASTTACHED LISTED SCHEDULE.
                            </a>
                          </td>
                          <td>17.06.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18051526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ADMISSION IN TWO YEARS 179 AUXILIARY NURSING &
                              MIDWIFERY (ANM) COURSE FOR URBAN PUBLIC HEALTH
                              CENTER (UPHC) UNDER KOLKATA CITY NUHM SOCIETY
                            </a>
                          </td>
                          <td>14.06.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18051626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Notice of Personality Test for Recruitment of
                              Technical Personnel (AutoCAD)
                            </a>
                          </td>
                          <td>13.06.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18051726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF SPECIALIST MEDICAL OFFICER OF
                              GYNAECOLOGIST, ANESTHETIST, CARDIOLOGIST,
                              SONOLOGIST, RADIOLOGIST FOR ITS GARDEN REACH
                              MATERNITY HOME AND OTHER MATERNITY HOMES IN
                              KOLKATA MUNICIPAL CORPORATION ON THE BASIS OF
                              CONTRACT OF PAYMENT CASE TO CASE BASIS THROUGH
                              WALK-IN-INTERVIEW, AGAINST ADV. H/01/KMC/2018-19 ,
                              DATED:08.05.2019.
                            </a>
                          </td>
                          <td>07.06.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18051826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF 1 (ONE) LAB-TECH (CONTRACTUAL)
                              RESERVED CAREGORY (ST - 1) AND 2 (TWO) MEDICAL
                              OFFICER RNTCP (CONTRACTUAL) (UR - 2) FOR KOLKATA
                              RNTCP ON CONTRATUAL BASIS THROUGH WALK IN
                              INTERVIEW, AGAINST MEMO. NO. CTO/ KOL/Adm/094/2019
                              dated 22.05.2019 UNDER KOLKATA DISTRICT TB CONTROL
                              SOCIETY.
                            </a>
                          </td>
                          <td>13.06.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18051926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF 32 MEDICAL OFFICER FULL
                              TIME(CONTRACTUAL) RESERVED CAREGORY AND 28 MEDICAL
                              OFFICER PART TIME (CONTRACTUAL) FOR ITS URBAN
                              PRIMARY HELATH CENTRES IN KOLKATA CITY NUHM
                              SOCIETY AREAS ON CONTRATUAL BASIS THROUGH WALK IN
                              INTERVIEW, AGAINST ADV. NO. 01 KOLKATA CITY NUHM
                              SOCIETY /2019-20 AND ADVERTISEMENT NO 01 KOLKATA
                              CITY NUHM SOCIETY /2019-20
                            </a>
                          </td>
                          <td>28.05.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18052026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF STAFF NURSE (CONTRACTUAL) UNDER
                              KOLKATA CITY NUHM SOCIETY
                            </a>
                          </td>
                          <td>07.03.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18052126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF 38 (UR-06,UR(SPORTS PERSON) - 02,
                              UR(EX-SERVICEMAN)-04, UR (PWD) - 04, SC-13,
                              SC-EX-SERVICEMEN - 02, ST-07) LABORATORY
                              TECHNICIANS ON CONTRACTUAL BASIS FOR KOLKATA CITY
                              NUHM SOCIETY AGAINST ADVERTISEMENT NO. -
                              11/KOLKATA CITY NUHM SOCIETY/2018-2019 DATED
                              23.02.2019.
                            </a>
                          </td>
                          <td>23.02.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18052226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              NOTICE FOR INTERVIEW OF HEARING OFFICER.
                            </a>
                          </td>
                          <td>19.02.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18052326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF MEDICAL OFFICERS FULL-TIME
                              (CONTRACTUAL) RESERVED CATEGORY & MEDICAL OFFICERS
                              PART-TIME UNDER KOLKATA CITY NUHM SOCIETY THROUGH
                              WALK-IN-INTERVIEW AT THE PREMISES 5, S.N. BANERJEE
                              ROAD, KOLKATA - 700013
                            </a>
                          </td>
                          <td>12.02.2019</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18052426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              WALK IN INTERVIEW FOR (30) THIRTY NUMBERS OF
                              FULL-TIME MEDICAL OFFICER & (44) FORTY-FOUR
                              PART-TIME MEDICAL OFFICER PURELY ON CONTRACTUAL
                              BASIS FOR ITS URBAN PRIMARY HEATLH CENTERS UNDER
                              KOLKATA CITY NUHM SOCIETY, AGAINST ADV.
                              NO.15KOLKATA CITY NUHM SOCIETY2017-18 & AGAINST
                              ADV. NO.7KOLKATA CITY NUHM SOCIETY2017-18
                            </a>
                          </td>
                          <td>17.12.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18052526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Recruitment of AUTOCAD Personal (On contractual
                              service purely on temporary basis)
                            </a>
                          </td>
                          <td>08.12.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18052626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk -in- Interview for selection of contractual
                              engagement of 10(ten) Contractual Computer Knowing
                              Steno-Typist(English)
                            </a>
                          </td>
                          <td>12.11.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18052726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF 37 (THIRTY-SEVEN) MEDICAL OFFICERs
                              (PART-TIME) FOR ITS URBAN PRIMARY HEALTH CENTRES
                              IN KOLKATA CITY NUHM SOCIETY AREAS ON CONTRACTUAL
                              BASIS THROUGH WALK-IN-INTERVIEW, AGAINST ADV. NO.
                              6/KOLKATA CITY NUHM SOCIETY/2018-19, DATED -
                              03.10.2018
                            </a>
                          </td>
                          <td>03.10.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18052826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Applications are invited from the Superannuated/to
                              be Superannuated Govt.Officers for selection and
                              appointment on re-employment basis to the post of
                              Hearing Officer in KMC.
                            </a>
                          </td>
                          <td>18.09.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18052926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Advertisement no KMC/AMRUT/NULM-01/2016-17 dt.
                              16.06.2016 , had applied for the contractual
                              engagement in the posts of Manager (MIS&ME)
                            </a>
                          </td>
                          <td>17.07.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18053026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Advertisement no KMC/AMRUT/NULM-01/2016-17 dt.
                              16.06.2016 , had applied for the contractual
                              engagement in the posts of Multitasking Helper
                            </a>
                          </td>
                          <td>17.07.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18053126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Advertisement no KMC/AMRUT/NULM-01/2016-17 dt.
                              16.06.2016 , had applied for the contractual
                              engagement in the posts of Accountant
                            </a>
                          </td>
                          <td>17.07.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18053226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Advertisement no KMC/AMRUT/NULM-01/2016-17 dt.
                              16.06.2016 , had applied for the contractual
                              engagement in the posts of Dealing Assistant cum
                              DEO
                            </a>
                          </td>
                          <td>17.07.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18053326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF 191 (ONE-HUNDRED-NINETY-ONE) STAFF
                              NURSE FOR ITS URBAN PRIMARY HEALTH CENTERS IN
                              KOLKATA CITY AREA PURELY ON CONTRACTUAL BASIS
                              THROUGH WALK-IN-INTERVIEW, VIDE ADVERTISEMENT NO.
                              3/KOLKATA CITY NUHM SOCIETY/2018-2019, DATED -
                              02.06.2018
                            </a>
                          </td>
                          <td>04.06.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18053426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF 33 (THIRTY-THREE) MEDICAL OFFICERS
                              (PART-TIME) FOR ITS URBAN PRIMARY HEALTH CENTRES
                              IN KOLKATA CITY NUHM SOCIETY AREAS ON CONTRACTUAL
                              BASIS THROUGH WALK-IN-INTERVIEW, AGAINST ADV. NO.
                              2/KOLKATA CITY NUHM SOCIETY/2018-19, DATED -
                              01-06.2018
                            </a>
                          </td>
                          <td>01.06.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18053526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in-interview for contractual engagement of
                              veterinary officer(V.O)
                            </a>
                          </td>
                          <td>12.05.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18053626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              di ke WALK IN INTERVIEW FOR (30) THIRTY NUMBERS OF
                              PART-TIME MEDICAL OFFICERS PURELY ON CONTRACTUAL
                              BASIS FOR ITS URBAN PRIMARY HEATLH CENTERS UNDER
                              KOLKATA CITY NUHM SOCIETY, AGAINST ADV.
                              NO.1/KOLKATA CITY NUHM SOCIETY/2018-19, DATED -
                              04.04.2018.
                            </a>
                          </td>
                          <td>04.04.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18053726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF 12 (TWELVE) M.O.(FULL-TIME) FOR ITS
                              URBAN PRIMARY HEALTH CENTRES IN KOLKATA CITY AREA
                              PURELY ON CONTRACTUAL BASIS THROUGH
                              WALK-IN-INTERVIEW, AGAINST ADV. NO. 15/KOLKATA
                              CITY NUHM SOCIETY/2017-18, DATED - 19-03.2018.
                            </a>
                          </td>
                          <td>20.03.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18053826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF 42 (FORTY-TWO) LABORATORY
                              TECHNICIANS FOR ITS KOLKATA CITY NUHM SOCIETY
                              AREAS ON CONTRACTUAL BASIS THROUGH INTERVIEW,
                              AGAINST ADV. NO.14/KOLKATA CITY NUHM
                              SOCIETY/2017-18, DATED - 19-03.2018.
                            </a>
                          </td>
                          <td>20.03.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18053926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              FRESH ADVERTISEMENT FOR THE POST OF "SECRETARY,
                              MUHAMMADAN BURIAL BOARD".
                            </a>
                          </td>
                          <td>10.03.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18054026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF 14 (FOURTEEN) PHARMACISTS (UR-PH-01;
                              UR-EX.SERVICE MAN-05;UR-MERITORIOUS SPORTS
                              PERSON-02; S.C.-EX.SERVICEMAN-02;S.T.-04) ON
                              CONTRACTUAL BASIS, AGAINST ADV. NO. 13 / KOLKATA
                              CITY NUHM SOCIETY / 2017-18, DATED - 09.02.2018
                            </a>
                          </td>
                          <td>09.02.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18054126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              TEMPORARY ENGAGEMENT OF LT (RESERVED ST-2), M.O.
                              RNTCP (MEDICAL COLLEGE-UR-1), TBHV (UR-1) IN
                              KOLKATA RNTCP, AGAINST ADV. NO.
                              CTO/KOL/ADM/005/2018, DATED - 15.01.2018.
                            </a>
                          </td>
                          <td>29.01.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18054226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF M.O.(PART-TIME) FOR ITS URBAN
                              PRIMARY HEALTH CENTRES IN KOLKATA CITY AREA PURELY
                              ON CONTRACTUAL BASIS THROUGH WALK-IN-INTERVIEW,
                              AGAINST ADV. NO. 12/KOLKATA CITY NUHM
                              SOCIETY/2017-18, DATED - 29.01.2018.
                            </a>
                          </td>
                          <td>29.01.2018</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18054326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF 12 (TWELVE) NOS. OF MEDICAL OFFICERS
                              (FULL-TIME) (SC-4,ST-2,OBC--A-2,OBC-B-4) FOR ITS
                              URBAN PRIMARY HEALTH CENTERS IN KOLKATA CITY AREA
                              PURELY ON CONTRACTUAL BASIS THROUGH
                              WALK-IN-INTERVIEW ON 27.12.2017 / 11:30 AM,
                              AGAINST ADV.NO. 11/KOLKATA CITY NUHM
                              SOCIETY/2017-18, DATED - 18.12.2017
                            </a>
                          </td>
                          <td>18.12.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18054426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              WALK-IN-INTERVIEW FOR ENGAGEMENT OF GYNECOLOGIST,
                              ANESTHETIST, CARDIOLOGIST & SONOLOGIST /
                              RADIOLOGIST FOR ITS MATERNITY HOMES PURELY ON CASE
                              TO CASE BASIS, VIDE ADV. NO. H/00/243/2017-18,
                              DATED - 18.12.2017
                            </a>
                          </td>
                          <td>12.12.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18054526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF 47 (FORTY-SEVEN) NOS. OF MEDICAL
                              OFFICER (PART-TIME) FOR ITS URBAN PRIMARY HEALTH
                              CENTERS IN KOLKATA CITY AREA PURELY ON CONTRACTUAL
                              BASIS THROUGH WALK-IN-INTERVIEW ON 14.12.2017 /
                              11:30 AM AGAINST ADV.NO. 10/KOLKATA CITY NUHM
                              SOCIETY/2017-18, DATED - 04.12.2017
                            </a>
                          </td>
                          <td>05.12.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18054626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Corrigendum to Advertisement No.09/Kolkata City
                              NHUM Society/2017-18.
                            </a>
                          </td>
                          <td>27.11.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18054726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              WALK-IN-INTERVIEW FOR ENGAGEMENT OF THREE (3)
                              LAB.TECH (LT) (UR-1,ST-2), M.O. RNTCP FOR CNMCH-
                              UR-1, SENIOR MO (DRTB CENTRE MTM BORAL HOSP -
                              UR-1), AGAINST ADVT. MEMO NO.
                              CTO/KOL/ADM/121/2017, DATED -20.11.2017, FOR
                              KOLKATA DISTRICT TB CONTROL SOCIETY.
                            </a>
                          </td>
                          <td>25.11.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18054826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Corrigendum of Engagement of Auto-CAD
                              Professionals
                            </a>
                          </td>
                          <td>24.11.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18054926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              WALK-IN-INTERVIEW FOR ENGAGEMENT OF ONE HUNDRED
                              THIRTY NINE (139) 'STAFF NURSES' FOR ITS URBAN
                              PRIMARY HEALTH CENTERS UNDER KOLKATA CITY NUHM
                              SOCIETY AGAINST ADVERTISEMENT NO.09/KOLKATA CITY
                              NUHM SOCIETY/2017-18, DATED - 17.11.2017
                            </a>
                          </td>
                          <td>17.11.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18055026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of Auto-CAD Professionals
                            </a>
                          </td>
                          <td>07.11.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18055126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              WALK-IN-INTERVIEW FOR ENGAGEMENT OF ELEVEN (11)
                              MEDICAL OFFICERS (FULL-TIME) FOR ITS URBAN PRIMARY
                              HEALTH CENTERS UNDER KOLKATA CITY NUHM SOCIETY
                              AGAINST ADVERTISEMENT NO.07/KOLKATA CITY NUHM
                              SOCIETY/2017-18, DATED - 01.11.2017
                            </a>
                          </td>
                          <td>01.11.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18055226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF MEDICAL OFFICER (PART-TIME) FOR
                              URBAN PRIMARY HEALTH CENTERS IN KOLKATA CITY AREA
                              UNDER KOLKATA CITY NUHM SOCIETY AGAINST
                              ADVERTISEMENT NO.07/KOLKATA CITY NUHM
                              SOCIETY/2017-18, DATED - 23.09.2017
                            </a>
                          </td>
                          <td>23.09.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18055326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of 2(two) Inquiry Officers on
                              contractual basis
                            </a>
                          </td>
                          <td>21.09.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18055426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              RECRUITMENT OF MEDICAL OFFICER (PART-TIME)OF
                              KOLKATA CITY NUHM SOCIETY
                            </a>
                          </td>
                          <td>24.08.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18055526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Recruitment of Lab. Tech (ST-2) R.N.T.C.P.,
                              Kolkata, Special Drive for Reserved Catagory (ST)
                              on Contractual Basis
                            </a>
                          </td>
                          <td>16.08.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18055626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Recruitment of Assistant Engineer & Executive
                              Engineer for KEIIP on Contract Basis.
                            </a>
                          </td>
                          <td>08.08.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18055726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              WALK-IN-INTERVIEW FOR 06 (SIX) NUMBER OF X-RAY
                              TECHNICIANS PURELY ON CONTRACTUAL BASIS FOR HEALTH
                              DEPARTMENT, KOLKATA MUNICIPAL CORPORATION.
                            </a>
                          </td>
                          <td>28.07.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18055826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Recruitment Notice for I.T. Hardware Professional
                              (Contractual) at KEIIP.
                            </a>
                          </td>
                          <td>20.07.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18055926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF 08 (EIGHT) (CATEGORISED AS SC-2,
                              ST-02, OBC-A - 02, OBC-B - 02) MEDICAL OFFICERS
                              (FULLTIME) PURELY ON CONTRACTUAL BASIS UNDER
                              KOLKATA CITY NUHM SOCIETY FOR ITS URBAN PRIMARY
                              HEALTH CENTRES IN KOLKATA CITY AREA AGAINST
                              ADVERTISEMENT NO. 05 / KOLKATA CITY NUHM SOCIETY /
                              2017-18, DTD. 17.07.2017
                            </a>
                          </td>
                          <td>18.07.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18056026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF 60 (SIXTY) MEDICAL OFFICERS PURELY
                              ON CONTRACTUAL BASIS UNDER KOLKATA CITY NUHM
                              SOCIETY FOR ITS URBAN PRIMARY HEALTH CENTRES IN
                              KOLKATA CITY AREA AGAINST ADVERTISEMENT NO.
                              04/KOLKATA CITY NUHM SOCIETY / 2017-18, DTD.
                              05.07.2017
                            </a>
                          </td>
                          <td>08.07.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18056126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              RECRUITMENT OF ONE DATA ENTRY OPERATOR (ST), NINE
                              LAB. TECHNICIANS (SC-4, ST-2, OBC-A-2, OBC-B-1) &
                              ONE TBHV (SC-1) UNDER RNTCP, KOLKATA.
                            </a>
                          </td>
                          <td>21.07.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18056226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF 87 (EIGHTY-SEVEN) NOS. OF M.O.
                              (PART-TIME) PURELY ON CONTRACTUAL BASIS FOR URBAN
                              PRIMARY HEALTH CENTRES IN KOLKATA CITY AREA.
                            </a>
                          </td>
                          <td>09.06.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18056326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              FORMAT FOR MEDICAL CERTIFICATE FOR ANM TRAINEE.
                            </a>
                          </td>
                          <td>25.05.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18056426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              RECRUITMENT OF ONE (1) (UNRESERVED) MEDICAL
                              OFFICER AND ONE (1) (UNRESERVED) ACCOUNTANT, RNTCP
                              AGAINST VACANCIES PURELY ON CONTRACTUAL BASIS
                              INITIALLY FOR A PERIOD OF ONE YEAR (RENEWABLE ON
                              PERFORMANCE).
                            </a>
                          </td>
                          <td>22.04.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18056526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              COMPUTER TEST OF LABORATORY TECHNICIAN UNDER
                              KOLKATA CITY NUHM SOCIETY ON CONTRACTUAL BASIS ON
                              26.04.2017, 27.04.2017 & 28.04.2017.
                            </a>
                          </td>
                          <td>21.04.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18056626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF MEDICAL OFFICER (FULL-TIME) RESERVE
                              CATEGORY ON CONTRACTUAL BASIS AGAINST
                              ADVERTISEMENT NO. 1/ KOLKATA CITY NUHM SOCIETY /
                              2017-2018.
                            </a>
                          </td>
                          <td>08.04.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18056726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Engagement of Contractual Teachers for running
                              different KMCP Schools purely on temporary basis
                              in Education Department,KMC.
                            </a>
                          </td>
                          <td>01.04.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18056826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              RECRUITMENT OF ONE DATA ENTRY OPERATOR & FIVE LAB.
                              TECHNICIANS UNDER RNTCP,KOLKATA.
                            </a>
                          </td>
                          <td>23.03.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18056926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk in interview for the post of
                              Consultant,Electrical engineer and Mechanical
                              engineer on 05/04/2017.
                            </a>
                          </td>
                          <td>22.03.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18057026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF 100 NOS. OF LABORATORY TECHNICIANS
                              ON CONTRACTUAL BASIS AGAINST ADVERTISEMENT NO. 10
                              / KOLKATA CITY NUHM SOCIETY / 2016-2017.
                            </a>
                          </td>
                          <td>10.03.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18057126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Recruitment of MEDICAL OFFICER (PART-TIME).
                            </a>
                          </td>
                          <td>03.03.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18057226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Recruitment of 20 Staff Nurse(Contractual) needed
                              for MTM Boral TB Hospital for 6 Months (Renewable
                              if necessary).
                            </a>
                          </td>
                          <td>16.02.2017</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18057326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF 80 (EIGHTY) PHARMACISTS ON
                              CONTRACTUAL BASIS UNDER KOLKATA CITY NUHM SOCIETY.
                            </a>
                          </td>
                          <td>05.12.2016</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18057426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              ENGAGEMENT OF 65 (SIXTY-FIVE) FULL-TIME MEDICAL
                              OFFICER ON CONTRACTUAL BASIS UNDER KOLKATA CITY
                              NUHM SOCIETY.
                            </a>
                          </td>
                          <td>03.12.2016</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18057526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in-interview for the post of Medical officer
                              (Part-time) purely on contractual basis for
                              Kolkata City NUHM Society.
                            </a>
                          </td>
                          <td>09.11.2016</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18057626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in-interview for the post of Medical Officer
                              (Full Time) purely on contractual basis for
                              Kolkata City NUHM Society.
                            </a>
                          </td>
                          <td>28.09.2016</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18057726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Applications are invited from the Civil Engineers
                              of Empanelment of Geo-Technical Engineers.
                            </a>
                          </td>
                          <td>26.08.2016</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18057826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Notice for Walk-in Interview regarding Appointment
                              in Various Posts (On Contract Basis) at Kolkata
                              Environmental Improvement Investment Program
                              (KEIIP).
                            </a>
                          </td>
                          <td>26.08.2016</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18057926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Kolkata City NUHM Society will engage 79 Medical
                              Officer (Full-Time)
                            </a>
                          </td>
                          <td>11.08.2016</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18058026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Applications are invited for engagement of 228
                              (two hundred twenty eight) Staff Nurse on
                              contractual basis
                            </a>
                          </td>
                          <td>11.08.2016</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18058126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              CORRIGENDUM FOR THE EMPLOYMENT NOTICE NO
                              KMC/AMRUT/NULM-01/2016-17 DTD 16/6/2016 FOR THE
                              POST OF URBAN PLANNER UNDER AMRUT has been
                              extended upto 05-August-2016,upto 5 p.m
                            </a>
                          </td>
                          <td>29.07.2016</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18058226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              CORRIGENDUM FOR THE EMPLOYMENT NOTICE NO
                              KMC/AMRUT/NULM-01/2016-17 DTD 16/6/2016 FOR THE
                              POST OF URBAN PLANNER UNDER AMRUT
                            </a>
                          </td>
                          <td>14.07.2016</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18058326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Corrigendum to Recruitment Advt. No 6/Kolkata City
                              NUHM Society/2015-16 for Recruitment of 24(Twenty
                              Four) Part time Medical Officer under Kolkata City
                              NUHM Society, KMC.
                            </a>
                          </td>
                          <td>08.01.2016</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18058426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Re-Appointment Special Officer Building.
                            </a>
                          </td>
                          <td>28.10.2015</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18058526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Addendum - The last date of submission of
                              application for selection and appointment on
                              re-employment basis to the post
                            </a>
                          </td>
                          <td>05.10.2015</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18058626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Applications are invited from the Superannuated/to
                              be superannuated Govt. Officers for selection and
                              appointment on re-employment basis to the post of
                              Hearing Officer in KMC.
                            </a>
                          </td>
                          <td>29.09.2015</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18058726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Recruitment of Thirty part time and twelve full
                              time Medical Officers under Kolkata City NUHM
                              Society
                            </a>
                          </td>
                          <td>04.09.2015</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18058826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in -Interview for contractual engagement of
                              02(two) Nos. of Computer knowing Steno-typist
                            </a>
                          </td>
                          <td>06.08.2015</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18058926-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in Interview for contractual engagement of
                              Medical Officer (Specialist (G&O), Medical Officer
                              (Specialist Radiologist cum Sonologist), Medical
                              Officer Specialist (Anaesthetist), Medical Officer
                              Specialist (Pediatrician), O.T. Nurse.
                            </a>
                          </td>
                          <td>17.07.2015</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18059026-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Recruitment of 1 (one) TB / HIV Co-ordinator.
                            </a>
                          </td>
                          <td>02.07.2015</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18059126-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Recruitment in KEIIP/KMC.
                            </a>
                          </td>
                          <td>09.06.2015</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18059226-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Advertisement No. 1/Kolkata City NUHM Society /
                              2015-16.
                            </a>
                          </td>
                          <td>02.16.2015</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18059326-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Recruitment of Environment Specialist for KEIIP.
                            </a>
                          </td>
                          <td>16.03.2015</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18059426-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Walk-in-interview for contractual engagement of
                              various categories of Medical Officers &
                              Para-medical staff in KMC Health Dept.
                            </a>
                          </td>
                          <td>12.03.2015</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18059526-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Recruitment of Environmental,Social and GIS
                              Personnel for KEIIP, KMC
                            </a>
                          </td>
                          <td>21.02.2015</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18059626-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              CORRIGENDUM
                            </a>
                          </td>
                          <td>22.01.2015</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18059726-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Recruitment of Senior Medical Officer DRTB Centre
                              1 post(Contractual)
                            </a>
                          </td>
                          <td>14.01.2015</td>
                        </tr>

                        <tr tabIndex={0} align="left" valign="top">
                          <td>
                            <a
                              href={`${mainURL}/filestore/v1/files/id?fileStoreId=${"18059826-2a59-4f3c-8a94-891f18042026"}&tenantId=km.kolkata`}
                            >
                              Recruitment of DEO - 1 post(Contractual)
                            </a>
                          </td>
                          <td>13.12.2014</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default KMC_Recruitments;
